import React from 'react';
import PropTypes from 'prop-types';

import FieldLabel from '../FieldLabel';
import TextInput from '../TextInput';
import styles from './styles.scss';
import withValidation from '../../shared/withValidation';

class LabeledTextInput extends React.PureComponent {
  render() {
    const { editMode, label = '', value, isnLabel, placeholder, error } = this.props;

    return (
      <div>
        <FieldLabel isnLabel={isnLabel}>{label}</FieldLabel>
        <Choose>
          <When condition={editMode}>
            <TextInput {...this.props} placeholder={placeholder} />
          </When>
          <Otherwise>
            <label className={`d-block ${styles.label}`}>{value || '-'}</label>
            {error && <label className={styles.error}>{error}</label>}
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

LabeledTextInput.propTypes = {
  editMode: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  value: PropTypes.string,
  isnLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  allowBlank: PropTypes.bool,
  error: PropTypes.string,
};

export default withValidation(LabeledTextInput);



// WEBPACK FOOTER //
// src/components/shared/LabeledTextInput/index.jsx